import * as React from "react";
import { Icon } from "../actions/Icon";

/**
 * Pill filter (library: All / Recordings / Meetings) and suggestion chips under the Ask composer.
 */
export interface FilterChipProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  active?: boolean;
  variant?: "default" | "suggestion";
  size?: "md" | "lg";
  icon?: string;
  children: React.ReactNode;
}

export function FilterChip({
  active,
  variant = "default",
  size = "md",
  icon,
  className,
  children,
  ...rest
}: FilterChipProps): JSX.Element {
  const cls = ["gk-chip", variant !== "default" && "gk-chip--" + variant, size === "lg" && "gk-chip--lg", className]
    .filter(Boolean)
    .join(" ");
  return (
    <button type="button" className={cls} aria-pressed={variant === "default" ? !!active : undefined} {...rest}>
      {icon && <Icon name={icon} size={16} />}
      {children}
    </button>
  );
}
